<template>
  <div class="search-condition-wrap">
    <el-descriptions :column="2" size="large" style="width: 100%" v-if="getSearchCondition">
      <el-descriptions-item
        v-if="is_headquarters == 'true'"
        label-class-name="descriptions-label"
        class-name="descriptions-content"
        label="門市"
      >
        {{
          getSearchCondition.shop.id != ''
            ? getSearchCondition.shop.erp_id + ' ' + getSearchCondition.shop.name
            : '未設定'
        }}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="descriptions-label" label="交易日期" min-width="260px">
        {{ getDateText(getSearchCondition.datef) }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="button-wrap">
      <el-button type="primary" style="width: 110px" @click="openDialog('searchAnalysis')">修改條件</el-button>
    </div>
  </div>

  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { useGetters } from '@/utils/mapStore';
import { defineAsyncComponent } from 'vue';
import { useDialog } from '@/utils/dialog';
import { getFormatDate } from '@/utils/datetime';
export default {
  name: 'search-analysis',
  components: {
    AnalysisDialog: defineAsyncComponent(() => import('@/components/analysis/AnalysisDialog.vue')),
  },
  setup() {
    const is_headquarters = sessionStorage.getItem('is_headquarters');
    //取得條件
    const getSearchCondition = useGetters('analysis', ['getSearchCondition']);
    const getDateText = (arr) => {
      if (!arr || arr.length === 0) return '未設定';
      const d = getFormatDate();
      if (arr.every((e) => d === e)) return '當天';
      else return arr[0] + ' ~ ' + arr[1];
    };
    //彈窗
    const { dialogTemplate, openDialog } = useDialog();
    return { is_headquarters, getSearchCondition, dialogTemplate, openDialog, getDateText };
  },
};
</script>
<style lang="scss" scoped>
.search-condition-wrap {
  @include white-bg;
  display: flex;
  align-items: center;
  padding: 16px 22px 0;
  position: relative;
  .button-wrap {
    position: absolute;
    top: 16px;
    right: 22px;
  }
}
</style>
